export default [
  {
    url: "/",
    name: "Главный экран",
    slug: "home",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/news",
    name: "Новости",
    slug: "news",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/votings",
    name: "Голосования",
    slug: "votings",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/passes",
    name: "Пропускная система",
    slug: "passes",
    access: "security",
    countNotify: 0
  },
  {
    url: "/security",
    name: "Вызов охраны",
    slug: "security",
    access: "security",
    countNotify: 0
  },
  {
    url: "/services/categories",
    name: "Консьерж-сервис",
    slug: "services-categories",
    access: "admin",
    countNotify: 0
  },
  {
    url: null,
    name: "Бронирование",
    submenu: [
      {
        url: "/booking/events",
        name: "Мероприятия",
        slug: "booking-events"
      },
      {
        url: "/booking/categories",
        name: "Категории",
        slug: "booking-categories"
      }
    ],
    access: "admin",
    countNotify: 0
  },
  {
    url: "/requests",
    name: "Заявки",
    slug: "requests",
    access: "security",
    countNotify: 0
  },
  {
    url: "/cameras",
    name: "Камеры",
    slug: "cameras",
    access: "security",
    countNotify: 0
  },
  {
    url: "/residents",
    name: "Жители",
    slug: "residents",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/homes",
    name: "Список адресов",
    slug: "homes",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/employees",
    name: "Сотрудники",
    slug: "employees",
    access: "admin",
    countNotify: 0
  },
  {
    url: "/counters",
    name: "Счетчики",
    slug: "counters",
    access: "admin",
    countNotify: 0
  },
  {
    url: null,
    name: "Комм. платежи",
    submenu: [
      {
        url: "/communal-payments/bills",
        name: "Счета",
        slug: "communal-payments-bills",
        access: "admin"
      },
      {
        url: "/communal-payments/personal-accounts",
        name: "Лицевые счета",
        slug: "communal-payments-personal-accounts",
        access: "admin"
      },
      {
        url: "/communal-payments/tariffs",
        name: "Тарифы",
        slug: "communal-payments-tariffs",
        access: "admin"
      }
    ],
    access: "admin",
    countNotify: 0
  },
  {
    url: "/paid-services",
    name: "Платные услуги",
    slug: "paid-services",
    access: "admin",
    countNotify: 0
  },
  {
    url: null,
    name: "Маркет",
    submenu: [
      {
        url: "/market/products",
        name: "Товары",
        slug: "market-products"
      },
      {
        url: "/market/categories",
        name: "Категории",
        slug: "market-categories"
      },
      {
        url: "/market/orders",
        name: "Заказы",
        slug: "market-orders"
      }
    ],
    countNotify: 0
  },
  {
    url: null,
    name: "Кафе",
    submenu: [
      {
        url: "/cafe/dishes",
        name: "Меню",
        slug: "cafe-dishes"
      },
      {
        url: "/cafe/orders",
        name: "Заказы",
        slug: "cafe-orders"
      }
    ],
    countNotify: 0
  }
];
